import { render, staticRenderFns } from "./ServiceIdForm.vue?vue&type=template&id=03d8fd7a&scoped=true"
import script from "./ServiceIdForm.vue?vue&type=script&lang=ts"
export * from "./ServiceIdForm.vue?vue&type=script&lang=ts"
import style0 from "./ServiceIdForm.vue?vue&type=style&index=0&id=03d8fd7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8fd7a",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/search.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2FServiceIdForm.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports